function mmInitSplideMedia() {
	var splideElemMain = document.querySelector("#main-slider");
	var splideElemThumbnails = document.querySelector("#thumbnail-slider");
	// SLIDER PRODUCT
	var main = new Splide(splideElemMain, {
		type: "slide",
		rewind: true,
		pagination: false,
		arrows: false,
		perPage: 1,
		breakpoints: {
			1024: {
				perPage: 1,
			},
			768: {
				perPage: 1,
			},
		},
	});

	var thumbnails = new Splide(splideElemThumbnails, {
		type: "loop",
		direction: "ttb",
		heightRatio: 6.3,
		perPage: 4,
		gap: 21,
		cover: true,
		isNavigation: true,
		pagination: false,
		rewind: true,
		arrows: true,
		breakpoints: {
			1024: {
				destroy: true,
				height: 100,
			},
		},
	});
	main.sync(thumbnails);
	main.mount();
	thumbnails.mount();
}

function mmInitSlideReassurance() {
	var sliderReassurance = document.querySelector("#slider-reassurance");
	if (sliderReassurance != null) {
		new Splide(sliderReassurance, {
			type: "loop",
			pagination: true,
			arrows: false,
			perPage: 1,
			autoplay: true,
			interval: 5000,
		}).mount();
	}
}
function mmInitSlideCrossell() {
	var sliderCrossell = document.querySelector("#slider-crossell");
	if (sliderCrossell != null) {
		new Splide(sliderCrossell, {
			type: "slide",
			pagination: true,
			arrows: true,
			perPage: 1,
		}).mount();
	}
}

document.addEventListener(
	"DOMContentLoaded",
	() => {
		mmInitSplideMedia();
		mmInitSlideReassurance();
		mmInitSlideCrossell();
		mmUpsellVariant();
	},
	{ once: true }
);

function mmChangeQtty(delta, inputId) {
	var input = document.getElementById(inputId);

	if (delta == "-1" && input.value == "1") {
	} else {
		input.value = parseInt(input.value, 10) + parseInt(delta, 10);
	}

	var variant_selector = document.querySelector("variant-selector");
	let event = new Event("change");
	variant_selector.dispatchEvent(event);
}

if (window.screen.width < 768) {
	// STICKY CTA DISPLAY ONLY WHEN SCROLL AFTER TRUE CTA
	var derniere_position_de_scroll_connue = 0;
	var ticking = false;
	var CTA = document.querySelector(".mm-main-product-button-container");
	var variantSelector = document.querySelector("variant-selector");
	var CTA_position = CTA.getBoundingClientRect().y;

	function faireQuelqueChose(position_scroll) {
		if (position_scroll > CTA_position) {
			CTA.classList.add("mm-cta-sticky");
			variantSelector.classList.add("mm-cta-sticky");
		} else {
			CTA.classList.remove("mm-cta-sticky");
			variantSelector.classList.remove("mm-cta-sticky");
		}
	}

	window.addEventListener("scroll", function (e) {
		derniere_position_de_scroll_connue = window.scrollY;
		if (!ticking) {
			window.requestAnimationFrame(function () {
				faireQuelqueChose(derniere_position_de_scroll_connue);
				ticking = false;
			});
		}

		ticking = true;
	});
}

//crossell variant
function mmUpsellVariant() {
	var variantsContainer = document.querySelectorAll(".mm-product-card-upsell-variant");
	variantsContainer.forEach((variant) => {
		variant.addEventListener("change", changeUpsellVariant(variant));
	});
}
function changeUpsellVariant(variant) {
	options = Array.from(variant.querySelectorAll("select.mm-upsell-variant-values"), (select) => select.value);
	var variantData = variantData || JSON.parse(variant.querySelector('.mm-product-card-upsell-json[type="application/json"]').textContent);

	var currentVariant = variantData.find((variant) => {
		const findings = !variant.options
			.map((option, index) => {
				return options[index] === option;
			})
			.includes(false);

		if (findings) return variant;
	});
}

// Ouverture des dropdowns
var allDropdown = document.querySelectorAll(".mm-product-form-dropdown");
allDropdown.forEach((content) => {
	content.addEventListener("click", function () {
		this.classList.toggle("active");
		const content = this.nextElementSibling;
		if (content.style.height) {
			content.style.height = null;
		} else {
			content.style.height = content.scrollHeight + "px";
		}
		allDropdown.forEach((elem) => {
			if (elem != this) {
				elem.classList.remove("active");
				elem.nextElementSibling.style.height = null;
			}
		});
	});
});
// FORM
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange.bind(this));
		this.variantData = this.getVariantJSON();
	}

	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();
		if (this.currentVariant) {
			this.variantFetch();
			this.updateURL();
		}
	}

	getSelectedOptions() {
      console.log('test', this.querySelectorAll(".mm-product-variant-checkbox:checked"))
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
      console.log('this.options ',this.options )
	}

	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	updateURL() {
		// Vérifier si c'est le premier sélecteur de la page
		const allSelectors = document.querySelectorAll("variant-selector");
		const isPrimary = allSelectors[0] === this;

		// Ne mettre à jour l'URL que si c'est le premier sélecteur
		if (!isPrimary) {
			return;
		}

		if (!this.currentVariant) {
			console.log("no current variant");
			return;
		}

		// Préserver le préfixe de langue de l'URL courante
		const currentPath = window.location.pathname;
		const pathParts = currentPath.split('/').filter(part => part);
		const langPrefix = pathParts[0] !== 'products' ? `/${pathParts[0]}` : '';
		const productUrl = this.querySelector("#product_url-1").dataset.url;
		const fullUrl = `${langPrefix}${productUrl}?variant=${this.currentVariant.id}`;

		window.history.replaceState({}, "", fullUrl);
		console.log("updateURL Size", fullUrl);
	}

	variantFetch() {
		let variantUrl = `${this.querySelector("#product_url-1").dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
		this.updateElement(".mm-product-form-stock-container", html);
		this.updateElementOuter(".mm-main-product-button", html);
		this.updateElementsOuter(".mm-find-in-store-shops", html);
		//this.updateElementsOuter(".mm-product-form-variant-value", html);

		const findInStoreContainer = document.querySelector(".mm-find-in-store-popup-container");
		if (findInStoreContainer && findInStoreContainer.classList.contains("open")) {
			mmAdjustFindInStoreShopsHeight();
		}
	}

	/**
	 *
	 * @param {string} selector
	 * @param {HtmlElement} html
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	updateElementsOuter(selector, html) {
		const destinations = this.container.querySelectorAll(selector);
		const sources = html.querySelectorAll(selector);

		destinations.forEach((destination, index) => {
			const source = sources[index];
			if (source) {
				destination.outerHTML = source.outerHTML;
			}
		});
	}
}
customElements.define("variant-selector", VariantSelector);

class ProductFormVariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest(".mm-main-product-section");
		this.addEventListener("click", this.onProductChange.bind(this));
	}

	onProductChange() {
		this.changeColor();
		this.productFetch();
	}

	productFetch() {
		// Préserver le préfixe de langue de l'URL courante
		const currentPath = window.location.pathname;
		const pathParts = currentPath.split('/').filter(part => part);
		const langPrefix = pathParts[0] !== 'products' ? `/${pathParts[0]}` : '';

		let sectionUrl = `${langPrefix}/products/${this.dataset.productHandle}?variant=${this.dataset.variantId}&section_id=${this.dataset.sectionId}`;

		if (this.cached[sectionUrl]) {
			this.renderProductInfo(this.cached[sectionUrl]);
			return;
		}

		fetch(sectionUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[sectionUrl] = html;
				this.renderProductInfo(html);
				this.updateUrl();
			})
			.catch((e) => {
				console.error(e);
			});
	}

	renderProductInfo(html) {
		this.updateElement(".mm-product-medias", html);
		mmInitSplideMedia();
		this.updateElement(".mm-product-form-crossell", html);
		mmInitSlideCrossell();
		this.updateElementOuter("#product_id", html);

		// Mettre à jour tous les variant-selectors et les lier
		const variantSelectors = document.querySelectorAll("variant-selector");
		if (variantSelectors.length > 0) {
			// Mettre à jour le contenu de tous les sélecteurs
			variantSelectors.forEach((selector) => {
				selector.innerHTML = html.querySelector("variant-selector").innerHTML;
				selector.variantData = JSON.parse(selector.querySelector('[type="application/json"]').textContent);
			});

			// Mettre à jour uniquement le premier et lui faire propager les changements
			mmSyncVariantSelectors();
		}

		this.updateElement(".mm-breadcrumbs", html);
		this.updateElement(".mm-main-product-button", html);
		this.updateElement(".mm-product-title", html);
		this.updateElementDocument(".mm-dropdown_text-content-description", html);
		this.updateElementDocument(".mm-product-form-dropdown_icon", html);
		this.updateElementDocument(".mm-product-form_img-text-container", html);
		this.updateMultipleElement(".mm-product-form-variant-value", html);
		this.updateElementOuter(".mm-product-form-date-expedition", html);
	}

	changeColor() {
		var allColor = document.querySelectorAll("product-form-color-swatch");
		allColor.forEach((color) => {
			if (color != this) {
				color.classList.remove("is-active");
			} else {
				color.classList.add("is-active");
			}
		});
	}

	/**
	 *
	 * @param {string} selector
	 * @param {HtmlElement} html
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}
	updateElementDocument(selector, html) {
		const destination = document.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}
	updateMultipleElement(selector, html) {
		const destination = this.container.querySelectorAll(selector);
		const source = html.querySelectorAll(selector);

		if (source && destination) {
			// Only iterate up to the number of elements that actually exist in destination
			const minLength = Math.min(source.length, destination.length);
			for (let index = 0; index < minLength; index++) {
				destination[index].outerHTML = source[index].outerHTML;
			}
		}
	}

	updateUrl() {
		// Préserver le préfixe de langue de l'URL courante
		const currentPath = window.location.pathname;
		const pathParts = currentPath.split('/').filter(part => part);
		const langPrefix = pathParts[0] !== 'products' ? `/${pathParts[0]}` : '';
		const fullUrl = `${langPrefix}/products/${this.dataset.productHandle}?variant=${this.dataset.variantId}`;

		window.history.replaceState({}, "", fullUrl);
		console.log("updateUrl Color", fullUrl);
	}
}
customElements.define("product-form-color-swatch", ProductFormVariantSelector);

function mmSyncOtherVariantSelector(clickedElem) {
	const value = clickedElem.value;
	const inputsToCheck = document.querySelectorAll(`.mm-product-variant-checkbox[value="${value}"]`);

	// Garder une trace des variant-selectors déjà traités
	const processedSelectors = new Set();

	inputsToCheck.forEach(function (inputToCheck) {
		// Cochage silencieux sans déclencher d'événements
		inputToCheck.checked = true;

		let variantSelector = inputToCheck.closest("variant-selector");
		if (variantSelector && !processedSelectors.has(variantSelector)) {
			// Ne déclencher l'événement que sur les variant-selectors non encore traités
			processedSelectors.add(variantSelector);
			variantSelector.dispatchEvent(new Event("change"));
		}
	});
}

function mmOpenSizeGuide() {
	var modal = document.querySelector(".mm-product-form-size-guide-modal");
	modal.classList.toggle("open");
}
function mmOpenPopUp(elem) {
	var modal = document.querySelector(elem);
	modal.classList.toggle("open");
}
function mmOpenFindInStore() {
	var modal = document.querySelector(".mm-find-in-store-popup-container");
	var html = document.querySelector("html");
	html.classList.toggle("stop-scrolling");
	modal.classList.toggle("open");
}
function mmAdjustFindInStoreShopsHeight() {
	const header = document.querySelector(".mm-find-in-store-popup-header");
	const content = document.querySelector(".mm-find-in-store-popup-content");
	const shops = document.querySelector(".mm-find-in-store-shops");

	if (!header || !content || !shops) return;

	// Hauteur disponible (viewport)
	const viewportHeight = window.innerHeight;

	// Hauteurs des éléments à soustraire
	const headerHeight = header.offsetHeight;
	const contentHeight = content.offsetHeight;

	// Calculer la hauteur restante
	const remainingHeight = viewportHeight - headerHeight - contentHeight;

	// Appliquer la hauteur calculée
	shops.style.height = `${remainingHeight}px`;
}

document.addEventListener("DOMContentLoaded", function () {
	// Ajout d'un écouteur sur le bouton d'ouverture du panneau
	const findInStoreButtons = document.querySelectorAll('[onclick="mmOpenFindInStore()"]');
	findInStoreButtons.forEach((button) => {
		button.addEventListener("click", function () {
			// Laisser le temps au panneau de s'ouvrir avant de calculer
			setTimeout(mmAdjustFindInStoreShopsHeight, 50);
		});
	});

	// Ajout d'un écouteur au redimensionnement
	window.addEventListener("resize", function () {
		const findInStoreContainer = document.querySelector(".mm-find-in-store-popup-container");
		if (findInStoreContainer && findInStoreContainer.classList.contains("open")) {
			mmAdjustFindInStoreShopsHeight();
		}
	});

	// Ajout d'un observateur de mutations pour détecter les changements dans le contenu
	const storeShopsContainer = document.querySelector(".mm-find-in-store-shops");
	if (storeShopsContainer) {
		const observer = new MutationObserver(function () {
			const findInStoreContainer = document.querySelector(".mm-find-in-store-popup-container");
			if (findInStoreContainer && findInStoreContainer.classList.contains("open")) {
				mmAdjustFindInStoreShopsHeight();
			}
		});

		observer.observe(storeShopsContainer, { childList: true, subtree: true });
	}
});

// Ajoutez cette nouvelle fonction pour gérer la synchronisation globale
function mmSyncVariantSelectors() {
	// Obtenir tous les sélecteurs de variantes
	const variantSelectors = document.querySelectorAll("variant-selector");
	if (variantSelectors.length <= 1) return;

	// Ajouter un écouteur au premier sélecteur pour propager les changements
	const mainSelector = variantSelectors[0];

	// Trouver les variantes sélectionnées
	const selectedOptions = Array.from(mainSelector.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);

	// Mettre à jour tous les autres sélecteurs
	for (let i = 1; i < variantSelectors.length; i++) {
		const otherSelector = variantSelectors[i];

		// Pour chaque option sélectionnée dans le sélecteur principal
		selectedOptions.forEach((value) => {
			const checkboxToSelect = otherSelector.querySelector(`.mm-product-variant-checkbox[value="${value}"]`);
			if (checkboxToSelect) {
				checkboxToSelect.checked = true;
			}
		});
	}

	// Déclencher un seul événement change sur le sélecteur principal
	mainSelector.dispatchEvent(new Event("change"));
}
